module.exports = __webpack_public_path__ + "static/img/pro5.20c284b6.jpg";